import { useContext } from "react";
import FeedbackContext from "../providers/FeedbackContext";


function useFeedback() {
    return useContext(FeedbackContext);
}

export default useFeedback